export default "__VITE_ASSET__BEbGzl_c__"